import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import AppContent from '@components/App/appContent';
import { Button, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { updateSubscription } from '../../../../actions/globalDataAction.js';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';
import HelpButtonTooltip from '../../../components/Common/HelpButton/HelpButtonTooltip.js';
import UserAvatar from '../../../components/Common/UserAvatar';
import AdminSettingsTitle from '../Common/AdminSettingsTitle.js';
import InviteUser from './InviteUser.js';
import { ORG_VIEWER } from '../../../components/Common/Utils/userPermissionsUtils.js';
import { initSubscriptionModal, openSubscriptionModal } from '../../../../actions/upgradeSubscriptionActions.js';
import { withTranslation } from 'react-i18next';


const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    admin: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 52,
        height: 22,
        borderRadius: 4,
        backgroundColor: '#4b32f2',
        border: 'solid 1px #4b32f2',
    },
    adminText: {
        display: 'inline-block',
        fontFamily: '"Roboto"',
        fontSize: 14,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: 0.5,
        textAlign: 'left',
        color: '#ffffff',
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
})

const GuestUsers = (props) => {
    return props.guestUsers.map((user) => {
        return <ListItem
            button
            onClick={() => {

            }} >
            <UserAvatar userUUID={user.auth0_id} withShadow={false} />
            <ListItemText
                primary={user.firstname + " " + user.lastname + ' (Guest)'}
                secondary={user.email} />

        </ListItem>
    })
}


const RemovedUsers = (props) => {

    const dateToCompare = (new Date('2023-01-01')).getTime();

    return props.removedUsers.map((user) => {
        console.log(user.lastModification)

        return <ListItem
            button
            onClick={() => {

            }} >
            <UserAvatar userUUID={user.auth0_id} withShadow={false} />
            <ListItemText
                primary={user.firstname + " " + user.lastname + ' (REMOVED)'}
                secondary={user.email} />
            {(new Date(user.lastModification)).getTime() > dateToCompare? <ListItemSecondaryAction style={{ paddingRight: 16 }}>
                <Button size={"small"} onClick={() => { props.restoreUser(user.id) }} variant="contained" color="primary">
                    {props.t('Restore user')}
                </Button>
            </ListItemSecondaryAction> : null}
        </ListItem>
    })
}


export class UsersManagement extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoaded: false,
        }
    }

    loadData = () => {
        const { billingService, dispatch, t } = this.props;

        billingService.getCurrentSubscription().then((result) => {
            dispatch(updateSubscription(result))
            this.setState({ isLoaded: true })
        })
    }


    componentDidMount() {
        this.loadData()
    }

    canAddUsers = () => {
        const { users, subscription } = this.props;

        return subscription.numberOfUsers > users.filter(x => x.status === 0).length
    }

    openSubscriptionDialog = () => {
        const { dispatch } = this.props;
        dispatch(initSubscriptionModal({ reason: 'users', mode: 'existed' }))
        dispatch(openSubscriptionModal())
    }

    render() {
        const { classes, dispatch, users, t, userSettingsService } = this.props;
        const { isLoaded } = this.state;


        if (!isLoaded || !users || users.length === 0) {
            return null
        }
        let activeUsers = users.filter(x => x.status === 0)
        let guestUsers = users.filter(x => x.status === 4)

        let removedUsers = users.filter(x => x.status === 5)


        let activeContent = activeUsers.map((user, index) => {
            return <ListItem
                button
                onClick={() => {
                    // Set mapping as currently editted
                    dispatch({ type: 'MAPPING_EDIT_USER', currentUser: user })

                    // Goto editing page
                    this.props.goTo({ pathname: '/admin/users/edit' })
                }} >
                <UserAvatar userUUID={user.auth0_id} withShadow={false} />
                <ListItemText
                    primary={(index + 1) + ') ' + user.firstname + " " + user.lastname}
                    secondary={user.email} />
                {user.role === "Admin" ?
                    <ListItemSecondaryAction style={{ paddingRight: 16 }}>
                        <div data-intrcm-id="usersManagement_735c6gy4" className={classes.admin}>
                            <span className={classes.adminText}>{t("Admin")}</span>
                        </div>
                    </ListItemSecondaryAction> : null}
            </ListItem>
        })

        let guestUsersContent = <GuestUsers guestUsers={guestUsers} />
        let archiveContent = <RemovedUsers removedUsers={removedUsers} t={t} restoreUser={(userId) => { userSettingsService.restoreUser(userId).then(() => { window.location.reload(); }) }} />

        return <AppContent >
            <PageContentWrapper drawer={<AdminSettingsDrawer selected="users" />}>
                <Grid spacing={16}>

                    <Grid container justify="space-between" alignItems='center'>
                        <HelpButtonTooltip link='articles/5387615-manage-users'>
                            <AdminSettingsTitle text={t('Manage users')} />
                        </HelpButtonTooltip>
                        {
                            this.canAddUsers() ? <InviteUser /> :
                                <Button onClick={this.openSubscriptionDialog} variant="contained" color="secondary">
                                    {t('Invite User')}
                                </Button>
                        }
                    </Grid>

                    <Paper className={classes.paperStyle}>
                        <List className={classes.listStyle}>
                            {activeContent}
                        </List>
                    </Paper>
                    {guestUsers && guestUsers.length > 0 ? <Fragment>
                        <AdminSettingsTitle text={t('Guest users')} />
                        <Paper className={classes.paperStyle}>
                            <List className={classes.listStyle}>
                                {guestUsersContent}
                            </List>
                        </Paper>
                    </Fragment> : null}
                    <AdminSettingsTitle text={t('Removed users')} />
                    <Paper className={classes.paperStyle}>
                        <List className={classes.listStyle}>
                            {archiveContent}
                        </List>
                    </Paper>
                </Grid>
            </PageContentWrapper>
        </AppContent>;
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    templates: state.globalData.templates,
    subscription: state.globalData.currentSubscription,
    users: state.globalData.users
})

const mapDispatchToProps = dispatch => {
    return {
        goTo: path => { dispatch(push(path)) },

        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    withTranslation('userEditModal'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(UsersManagement);